<template>
  <div class="location-device-item-bd ubv">
    <div class="title">
      <span style="color: #4d4d4d">{{ location.locationName }}</span>
      <span v-if="site.siteName">&ensp;>&ensp;{{ site.siteName||'-' }}</span>
    </div>
    <div class="ub" style="margin-bottom: 24px">
      <el-button v-if="funcView.device_location_move" type="warning" style="margin-right: 16px" @click="onMoveDevice()" :disabled="!tableSelect.length">
        <i class="icon icon-yidong"></i>
        <span>&ensp;{{ $t('location_device_item.zhuan_yi') }}</span>
      </el-button>
      <div class="ub-f1">
        <search-input width="100%" :placeholder="$t('location_device_item.jshsbmc')" v-model="formSearch.search" @fetch="onPageChange({ page: 1 })"></search-input>
      </div>
    </div>
    <div class="table-bd ub-f1">
      <custom-table height="100%" stripe type="checkbox" tableCode="portal_location_device" v-model="tableSelect" :data="tableList">
        <el-table-column fixed="right" width="130">
          <template slot-scope="scope" v-if="funcView.device_location_move || funcView.device_area_move">
            <el-button type="text" size="mini" @click="onMoveDevice(scope.row)">
              <i class="icon icon-yidong"></i>
              <span>&ensp;{{ $t('location_device_item.zhuan_yi') }}</span>
            </el-button>
          </template>
        </el-table-column>
      </custom-table>
    </div>
    <div class="table-page">
      <custom-pagination :total="totalRows" :page="formSearch.pageNum" :size="formSearch.pageSize" @change="onPageChange"></custom-pagination>
    </div>
    <!-- 转移 -->
    <location-device-dialog v-if="dialogVisible" :model="dialogModel" @close="dialogVisible = false" @success="onSuccess()"></location-device-dialog>
  </div>
</template>

<script>
import apis from '@/utils/apis';
import locationDeviceDialog from './location_device_dialog.vue';

export default {
  name: 'location_device_item',
  components: { locationDeviceDialog },
  props: {
    location: {
      type: Object,
      default() {
        return {};
      },
    },
    site: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      dialogVisible: false,
      dialogModel: {},
      formSearch: {
        dataType: '', // JV需要为2
        locationId: '',
        siteId: '',
        search: '',
        pageSize: 50,
        pageNum: 1,
      },
      tableSelect: [],
      tableList: [],
      totalRows: 0,
      // 请求防抖
      getDeviceListHandler: null
    };
  },
  computed: {
    isJV() {
      return this.$store.state.userInfo && this.$store.state.userInfo.bizType === 'JV';
    },
  },
  watch: {
    location: function () {
      this.formSearch = JSON.parse(this.resetFormSearch);
      this.deviceList = [];
      this.totalRows = 0;
      this.getDeviceListHandler();
    },
    site: function () {
      this.formSearch = JSON.parse(this.resetFormSearch);
      this.deviceList = [];
      this.totalRows = 0;
      this.getDeviceListHandler();
    },
  },
  mounted: function () {
    this.resetFormSearch = JSON.stringify(this.formSearch);
    // this.getDeviceList();
    this.getDeviceListHandler = this.$debounce(() => {
      // 防抖处理  表格重绘
      this.getDeviceList();
    }, 200);
    this.getDeviceListHandler();
    this.getFuncView();
  },
  methods: {
    // 获取设备列表
    getDeviceList: function () {
      this.formSearch.locationId = this.location.locationId;
      this.formSearch.siteId = this.site.siteId;
      this.formSearch.dataType = this.isJV ? 2 : null;
      this.$getJSON(apis.portalLocationDevicePage, this.formSearch).then((res) => {
        this.tableList = res.data.list;
        this.totalRows = res.data.total;
      });
    },
    // 分页变更
    onPageChange: function ({ page, size }) {
      this.formSearch.pageNum = page;
      this.formSearch.pageSize = size || this.formSearch.pageSize;
      this.getDeviceList();
    },
    // 转移设备
    onMoveDevice: function (device) {
      this.dialogModel = {
        title: this.$t('location_device_item.ji_qi_zhuan_yi'),
        tableSelect: device
          ? [{ ...device, locationId: this.location.locationId, siteId: this.site.siteId }]
          : this.tableSelect.map((i) => {
            const obj = i;
            obj.locationId = this.location.locationId;
            obj.siteId = this.site.siteId;
            return obj;
          }),
      };
      this.dialogVisible = true;
    },
    onSuccess() {
      this.getDeviceList();
    },
  },
};
</script>

<style lang="scss">
@import '@/style/colors.scss';

.location-device-item-bd {
  height: 100%;
  .title {
    height: 40px;
    line-height: 40px;
    font-size: 14px;
    color: $--color-primary;
    font-weight: bold;
    margin-bottom: 24px;
  }
}
</style>
